<template>
  <div class="text-field" :class="{'text-field--pushed-label': labelPushed,
    'textHasError': error}">
    <div class="text-field__control">
      <label
        class="text-field__label"
        :class="{'has-text-danger': error}"
        :for="name">
        {{label}}
      </label>
      <input
        @blur="$emit('blur', $event)"
        :name="name"
        :id="name"
        :disabled="disabled"
        :min="min"
        :max="max"
        :value="value"
        @keyup.enter="$emit('enterKey', $event.target.value)"
        @input="$emit('input', $event.target.value)"
        @focusin="active = true"
        @focusout="active = false"
        v-bind="$attrs"
      >
    </div>
    <span class="text-field__error has-text-danger" v-if="error">
      {{error}}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'WTextField',
    props: {
      name: String,
      label: String,
      error: String,
      min: Number,
      max: Number,
      value: [String, Number],
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        active: false,
      };
    },
    computed: {
      labelPushed() {
        return this.active || this.value;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../assets/styles/variables";

  .text-field {
    padding: 12px 0;
    width: 392px;
    @media(max-width: 996px) {
      width: 100%;
    }
    .text-field__control {
      position: relative;
    }

    .text-field__label {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      font-size: 14px;
      color: $text-body;
      padding: 4px 16px;
      transform: translateY(-50%);
      transition: all 0.2s;
      font-weight: 500;
      pointer-events: none;
    }

    input {
      width: 100%;
      height: 56px;
      border-radius: 16px;
      box-shadow: none;
      padding: 8px 16px;
      font-size: 14px;
      line-height: 14px;
      border: 1px solid transparent;
      transition: all 0.5s;
      outline: none;
      font-family: 'Roboto';

      &::placeholder {
        color: $text-body;
      }

      &:focus {
        border-color: $primary-main;

        @include shadow-4;
      }

      &:disabled {
        background-color: $background-4;
        color: $text-body;
      }
    }
    input:-internal-autofill-selected {
      background-color: white !important;
      background: white !important;
    }

    &.text-field--pushed-label {
      .text-field__label {
        top: 12px;
        font-size: 12px;
      }

      input {
        padding-top: 16px;
      }
    }

    .text-field__error {
      position: relative;
      font-size: 14px;
      width: 21%;
      padding-left: 16px;
      display: table-cell;
    }
  }

  .requts {
    .text-field {
      .text-field__label {
        left: 6%;
      }
      input {
        padding: 8px 16px 8px 38px;
      }
    }
  }
  .textHasError {
    padding-bottom: 0 !important;
  }
</style>
